<div class="video-container" [class.hidden]="!visible">
  <video
    [ngStyle]="{ 'background-image': 'url(' + imageUrl + ')' }"
    #video
    [width]="width"
    [height]="height"
    autoplay
  ></video>
  <div class="action-buttons">
    <label class="file-upload-button mat-flat-button mat-button-base mat-accent">
      <input type="file" accept="image/*,video/*" (change)="readFile($event)" />
      Upload
    </label>
    <button mat-fab color="accent" (click)="onCapture()" class="capture-btn">
      <mat-icon>camera</mat-icon>
    </button>
    <button mat-fab color="accent" (click)="switchCamera()" class="switch-btn">
      <mat-icon>flip_camera_android</mat-icon>
    </button>
  </div>
  <canvas #canvas [width]="width" [height]="height"></canvas>
</div>
